import { formatMoney, cachedFetch, extractSectionId } from "//www.mangrovediamonds.com/cdn/shop/t/6/assets/theme.js?v=112701401618831908181787379769";

var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
const PriceRange = (function() {
  var selectors = {
    priceRange: '.price-range',
    priceRangeSlider: '.price-range__slider',
    priceRangeInputMin: '.price-range__input-min',
    priceRangeInputMax: '.price-range__input-max',
    priceRangeDisplayMin: '.price-range__display-min',
    priceRangeDisplayMax: '.price-range__display-max',
    hiddenInputMin: '.range__input-min',
    hiddenInputMax: '.range__input-max',
  };

  function PriceRange(container, { onChange, onUpdate, ...sliderOptions } = {}) {
    this.container = container;
    this.onChange = onChange;
    this.onUpdate = onUpdate;
    this.sliderOptions = sliderOptions || {};

    return this.init();
  }

  PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
    init: function() {
      if (!this.container.classList.contains('diamond-price-range')) {
        throw new Error('You must instantiate PriceRange with a valid container')
      }

      this.formEl = this.container.closest('form');
      this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
      this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
      this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
      this.hiddenMinEl = this.container.querySelector(selectors.hiddenInputMin);
      this.hiddenMaxEl = this.container.querySelector(selectors.hiddenInputMax);
      this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
      this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);

      this.minRange = parseFloat(this.container.dataset.min) || 0;
      this.minValue = parseFloat(this.container.dataset.minValue) || 0;
      this.maxRange = parseFloat(this.container.dataset.max) || 100;
      this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;
      this.step = parseFloat(this.container.dataset.step) || 1;
      this.values = this.container.dataset.values.split(",").map(i => i.trim());

      if (this.values.length > 1) {
        var format = {
          to: (value) => {
            return this.values[Math.round(value)];
          },
          from: (value) => {
            return this.values.indexOf(value);
          }
        };

        this.sliderOptions = {
          ...this.sliderOptions,
          start: [this.values[0], this.values[this.values.length - 1]],
          range: { min: 0, max: this.values.length - 1 },
          step: 1,
          format: format,
          pips: { mode: 'steps', format: format },
        }
      }

      return this.createPriceRange();
    },

    createPriceRange: function() {
      if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
        this.sliderEl.noUiSlider.destroy();
      }

      var slider = noUiSlider.create(this.sliderEl, {
        connect: true,
        step: this.step,
        start: [this.minValue, this.maxValue],
        range: {
          min: this.minRange,
          max: this.maxRange,
        },
        ...this.sliderOptions,
      });

      slider.on('update', values => {
        const isPrice = this.container.dataset.name === 'prices[]'
        if (this.displayMinEl && this.displayMaxEl) {
          this.displayMinEl.innerHTML = isPrice ? formatMoney(values[0], window.themeVariables.settings.moneyFormat) : values[0];
          this.displayMaxEl.innerHTML = isPrice ? formatMoney(values[1], window.themeVariables.settings.moneyFormat) : values[1];
        }
        this.inputMinEl.value = isPrice ? Math.floor(values[0]) : values[0];
        this.inputMaxEl.value = isPrice ? Math.floor(values[1]) : values[1];
      });

      slider.on('change', values => {
        const isPrice = this.container.dataset.name === 'prices[]'
        const userField = document.querySelector('[name=user]');
        userField.checked = true;
        this.inputMinEl.value = isPrice ? Math.floor(values[0]) : values[0];
        this.inputMaxEl.value = isPrice ? Math.floor(values[1]) : values[1];
        this.inputMinEl.dispatchEvent(new Event('change', { bubbles: true }));
      });

      if (this.values.length > 1) {
        this.sliderEl.querySelectorAll('.noUi-value').forEach(pip => {
          let index = Number(pip.getAttribute('data-value'));
          pip.addEventListener('click', () => {
            let pointer = (this.values.length / 2) - index
            slider.set([pointer > 0 ? this.values[index] : null, pointer <= 0 ? this.values[index] : null])
          })
          this.inputMinEl.dispatchEvent(new Event('change', { bubbles: true }));
        });

        return slider;
      }

      this.inputMinEl.addEventListener("change", (event) => {
        event.preventDefault();
        const userField = document.querySelector('[name=user]');
        userField.checked = true;
        const current = slider.get()
        event.target.value = Math.max(parseFloat(event.target.value), this.minRange);
        slider.set([event.target.value, null])
      });
      this.inputMaxEl.addEventListener("change", (event) => {
        event.preventDefault();
        const userField = document.querySelector('[name=user]');
        userField.checked = true;
        const current = slider.get()
        event.target.value = Math.min(parseFloat(event.target.value), this.maxRange);
        slider.set([null, event.target.value])
      });

      return slider;
    },
  });

  return PriceRange;
})();

var DiamondRange = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.slider = new PriceRange(this)
  }
}

if (!window.customElements.get("diamond-range")) {
  window.customElements.define("diamond-range", DiamondRange);
}


var abortController = null;
document.addEventListener("diamond:update", async (event) => {
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
  const url = event.detail.url, shopifySection = document.getElementById(`shopify-section-${url.searchParams.get("section_id")}`);
  const facet_url = new URL(url)

  try {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    const response = await cachedFetch(url.toString(), { signal: abortController.signal });
    const { data: diamonds, current_page, total_count, total_pages } = await response.json();
    const tempContent = new DOMParser().parseFromString(renderDiamonds(diamonds), "text/html");
    const activefacetContent = new DOMParser().parseFromString(active_facets({url: facet_url}), "text/html")
    const pagiContent = new DOMParser().parseFromString(renderPagination({ url: new URL(url), current_page, total_count: total_pages }), "text/html")

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));

    const mainTable = shopifySection.querySelector("tbody")
    const paginationDiv = shopifySection.querySelector(".diamond-pagination")
    const activeFacetDiv = shopifySection.querySelector(".active-facets")
    mainTable.replaceChildren(...document.importNode(tempContent.querySelector("tbody"), true).childNodes);
    paginationDiv.replaceChildren(...document.importNode(pagiContent.querySelector(".content"), true).childNodes);
    activeFacetDiv.replaceChildren(...document.importNode(activefacetContent.querySelector(".active-facets"), true).childNodes);
    shopifySection.querySelector('.toolbar__products-count').innerHTML = `${total_count} Diamonds Awaiting For Your Selection`
    shopifySection.querySelector('diamond-table').setAttribute("data-url", url.toString());

    const shapeCheckboxes = Array.from(shopifySection.querySelectorAll('input[name="shape[]"]'));
    const allShapes = Array.from(url.searchParams.getAll('shape[]'));
    shapeCheckboxes.forEach(checkbox => {
      if (allShapes.includes(checkbox.value)) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    });

    const aiField = shopifySection.querySelector('[name=ai]');
    const hasAi = url.searchParams.get('ai');
    if (hasAi) {
      aiField.checked = true;
    } else {
      aiField.checked = false;
    }

    const heartField = shopifySection.querySelector('[name=heart_arrow]');
    const hasHeart = url.searchParams.get('heart_arrow');
    if (hasHeart) {
      heartField.checked = true;
    } else {
      heartField.checked = false;
    }

    const certifiedCheckbox = Array.from(shopifySection.querySelectorAll('input[name="certified_by[]"]'));
    const allCertificates = Array.from(url.searchParams.getAll('certified_by[]'));
    certifiedCheckbox.forEach(checkbox => {
      if (allCertificates.includes(checkbox.value)) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    });

    const colorCheckbox = Array.from(shopifySection.querySelectorAll('input[name="color[]"]'));
    const allColor = Array.from(url.searchParams.getAll('color[]'));
    colorCheckbox.forEach(checkbox => {
      if (allColor.includes(checkbox.value)) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    });

    const fancyCheckbox = Array.from(shopifySection.querySelectorAll('input[name="fancy[]"]'));
    const allfancy = Array.from(url.searchParams.getAll('fancy[]'));
    fancyCheckbox.forEach(checkbox => {
      if (allfancy.includes(checkbox.value)) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    });

    const typeCheckbox = Array.from(shopifySection.querySelectorAll('input[name="types[]"]'));
    const allTypes = Array.from(url.searchParams.getAll('types[]')).map((t) => decodeURIComponent(t));
    typeCheckbox.forEach(checkbox => {
      if (allTypes.includes(checkbox.value)) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    });

    const allRnages = Array.from(shopifySection.querySelectorAll('diamond-range'));
    allRnages.forEach(range => {
      const allValues = Array.from(url.searchParams.getAll(range.dataset.name));
      if (allValues.length > 0) {
        range.slider.set([allValues[0], allValues[allValues.length - 1]])
      } else {
        let values = range.dataset.values.split(",").map(i => i.trim());
        if (values.length > 1) {
          range.slider.set([values[0], values[values.length - 1]])
        } else {
          range.slider.set([parseFloat(range.dataset.minValue), parseFloat(range.dataset.maxValue)])
        }
      }
    })

    diamon_hover()
    wishlistEvents(shopifySection)
    if (event.detail.scroll) {
      const scrollToProductList = () => shopifySection.querySelector(".collection").scrollIntoView({ block: "start", behavior: "smooth" });
      if ("requestIdleCallback" in window) {
        requestIdleCallback(scrollToProductList, { timeout: 500 });
      } else {
        requestAnimationFrame(scrollToProductList);
      }
    }

    const params = new URL(url).searchParams;
    const paramsString = params.toString();
    sessionStorage.setItem('current_filters', paramsString)

  } catch (e) {
  }
})

function wishlistEvents(container) {
  container.querySelectorAll('.towishlist').forEach(elm => elm.addEventListener('click', async (e) => {
    e.preventDefault()

    try {
      const product_id = parseInt(elm.dataset.productId);
      let wishlistProducts = JSON.parse(localStorage.getItem('theme:wishlist-products') || '[]')
      const dbData = window.themeVariables.settings.wishlist;
      if (dbData) {
        wishlistProducts = [...wishlistProducts, ...dbData]
      }

      wishlistProducts = new Set(wishlistProducts)

      if (wishlistProducts.has(product_id)) {
        wishlistProducts.delete(product_id);
        elm.classList.remove('active')

        if (wishlistProducts.size > 0) {
          document.querySelector('[is="wishlist-link"]').classList.add('active')
        } else {
          document.querySelector('[is="wishlist-link"]').classList.remove('active')
        }
      } else {
        elm.classList.add('active')
        wishlistProducts.add(product_id);
        if (!document.querySelector('[is="wishlist-link"]').classList.contains('active')) {
          document.querySelector('[is="wishlist-link"]').classList.add('active')
        }
      }

      localStorage.setItem('theme:wishlist-products', JSON.stringify(Array.from(wishlistProducts.values()).reverse()));
      if (window.themeVariables.settings.customer) {
        await fetch('https://mangrove-api.quentin-3e1.workers.dev/api/wishlist', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({email: window.themeVariables.settings.customer, products: Array.from(wishlistProducts.values())}),
        })
      }
    } catch (e) {
      // Safari in private mode does not allow setting item, we silently fail
    }
  }))
}

function diamon_hover() {
  var tableRows = document.querySelectorAll('.diamonds-table-row');
  var activeRow = null;

  tableRows.forEach(function(row) {
    row.addEventListener('mouseenter', function() {
      if (activeRow) {
        activeRow.classList.remove('active');
      }
      activeRow = this;
      activeRow.classList.add('active');
      let { sku, girdle, shape, table, depth, culet, polish, measurements, symmetry, title } = row.dataset
      document.querySelectorAll('.js-diamond-overview-table-pct').forEach(element => element.innerHTML = table);
      document.querySelectorAll('.js-diamond-overview-girdle').forEach(element => element.innerHTML = girdle);
      document.querySelectorAll('.js-diamond-overview-culet').forEach(element => element.innerHTML = culet);
      document.querySelectorAll('.js-diamond-overview-depth-pct').forEach(element => element.innerHTML = depth);
      document.querySelectorAll('.js-diamond-overview-sku').forEach(element => element.innerHTML = sku);
      document.querySelectorAll('.js-diamond-overview-measurement').forEach(element => element.innerHTML = measurements);
      document.querySelectorAll('.js-diamond-overview-symmetry').forEach(element => element.innerHTML = symmetry);
      document.querySelectorAll('.js-diamond-overview-polish').forEach(element => element.innerHTML = polish);
      document.querySelectorAll('.js-diamond-overview-name').forEach(element => element.innerHTML = title);
      document.querySelector('.js-diamond-overview-specs').dataset.shape = shape;
      document.querySelector('.js-diamond-overview').classList.add('details-updated');
    });
  });
}

function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

function renderDiamonds(diamonds) {
  const wishlistProducts = new Set(JSON.parse(localStorage.getItem('theme:wishlist-products') || '[]'));
  let html = '<table><tbody>';
  diamonds.forEach(diamond => {
    const active_class = wishlistProducts.has(parseInt(diamond.productId)) ? ' active' : '';
    const shape = diamond.shape || 'round';
    const type = diamond.type === "Lab Diamond" ? 'Lab' : 'Natural';
    html += `
      <tr class="diamonds-table-row" data-product-id="${diamond.productId}" data-sku="${diamond.sku}" data-shape="${capitalizeFirstLetter(shape)}" data-culet="${diamond.culet}" data-depth="${diamond.depth}" data-table="${diamond.table}" data-girdle="${diamond.girdle}" data-polish="${diamond.polish}" data-symmetry="${diamond.symmetry}" data-measurements="${diamond.measurements}" data-title="${diamond.carat} Ct ${diamond.title}">
          <td class="diamonds-table-data" data-attr="diamond_image">
              <a href="/products/${diamond.handle}">
                  <img class="product-image-photo" src="//cdn.shopify.com/s/files/1/0713/3092/2806/t/4/assets/${shape.toLowerCase()}-sm.png" loading="lazy" width="40" height="40" alt="Emerald Lab Created Diamond" />
                  ${type}
              </a>
          </td>
          <td class="diamonds-table-data" data-attr="diamond_shape">
              <a href="/products/${diamond.handle}">${capitalizeFirstLetter(shape)}</a>
          </td>
          <td class="diamonds-table-data" data-attr="diamond_weight">
              <a href="/products/${diamond.handle}">${parseFloat(diamond.carat || 0).toFixed(2)}</a>
          </td>
          <td class="diamonds-table-data" data-attr="diamond_cut_grade">
              <a href="/products/${diamond.handle}">${(diamond.cut || 'Fancy').replace('IDEAL', 'Ideal').replace('ID', 'Ideal').replace('EX', 'Excellent').replace('VG', 'Very Good') }</a>
          </td>
          <td class="diamonds-table-data" data-attr="diamond_color">
              <a href="/products/${diamond.handle}">${diamond.color}</a>
          </td>
          <td class="diamonds-table-data" data-attr="diamond_clarity">
              <a href="/products/${diamond.handle}">${diamond.clarity}</a>
          </td>
          <td class="diamonds-table-data" data-attr="price">
              <a href="/products/${diamond.handle}">
                  <price-list class="price-list">
                    <sale-price class=""> <span class="sr-only">Sale price</span>${formatMoney(parseInt(diamond.price) * parseFloat(Shopify.currency.rate) * 100, window.themeVariables.settings.moneyFormat)}</sale-price>
                  </price-list>
              </a>
          </td>
          <td class="diamonds-table-data" data-attr="diamond_wishlist">
              <div data-role="add-to-links">
                  <a href="#" class="towishlist${active_class}" data-product-id="${diamond.productId}">
                      <span><i title="Add to Wishlist" class="icon-heart"></i></span>
                  </a>
              </div>
          </td>
          <td class="diamonds-table-data" data-attr="diamond_link">
            <a class="product-item-link" href="/products/${diamond.handle}">View</a>
          </td>
      </tr>
    `;
  });
  html += '</tbody></table>';

  return html;
}

function renderPagination({ url, current_page, total_count }) {
  let html = '<div><div class="content"><nav class="pagination" role="navigation" aria-label="Pagination">';
  const links = [];
  const range = 3;

  for (let page = 1; page <= total_count; page++) {
    const link = {
      label: page.toString(),
      active: page === current_page,
    };
    links.push(link);
  }

  const urlObj = new URL(url);

  if (current_page > 1) {
    urlObj.searchParams.set("page", current_page - 1);
    html += `
      <a is="diamond-link" class="pagination__link h6" rel="prev" aria-label="Previous Page" href="" data-url="${urlObj.toString()}">
        <svg aria-hidden="true" focusable="false" fill="none" width="11" class="icon icon-chevron-left  icon--direction-aware" viewBox="0 0 10 10">
          <path d="M7 1 3 5l4 4" stroke="currentColor" stroke-linecap="square"></path>
        </svg>
      </a>
    `
  }

  links.forEach(link => {
    let page = parseInt(link.label)
    if (page > current_page - 4 && page <= current_page + 3) {
      if (link.active) {
        html += `
          <span class="pagination__link pagination__link--disabled h6" aria-current="page"">
            ${link.label}
          </span>
        `
      } else {
        urlObj.searchParams.set("page", page);
        html += `
          <a is="diamond-link" class="pagination__link h6" aria-label="Go to ${link.label}" href="" data-url="${urlObj.toString()}">
            ${link.label}
          </a>
        `
      }
    }
  })

  if (current_page < total_count) {
    urlObj.searchParams.set("page", current_page + 1);
    html += `
      <a is="diamond-link" class="pagination__link h6" rel="next" aria-label="Next Page" data-url="${urlObj.toString()}" href="">
        <svg aria-hidden="true" focusable="false" fill="none" width="11" class="icon icon-chevron-right  icon--direction-aware" viewBox="0 0 10 10">
          <path d="m3 9 4-4-4-4" stroke="currentColor" stroke-linecap="square"></path>
        </svg>
      </a>
    `
  }

  html += '</nav></div></div>'

  return html
}

function active_facets({url}) {
  const params = url.searchParams;

  const queryParams = {};
  for (let [key, value] of params) {
    if (queryParams[key]) {
      if (Array.isArray(queryParams[key])) {
        queryParams[key].push(value);
      }
    } else {
      if (key.includes("[]")) {
        queryParams[key] = [value];
      } else {
        queryParams[key] = value;
      }
    }
  }

  let html = '<div><div class="active-facets">'

  if (queryParams['shape[]'] && queryParams['shape[]'].length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    queryParams['shape[]'].forEach(shape => {
      const updatedShapes = queryParams['shape[]'].filter(s => s !== shape);
      cloneParams.delete("shape[]");
      updatedShapes.forEach(shape => {
        cloneParams.append("shape[]", shape);
      });
      html += `
        <div class="removable-facet">
          <a href="" data-filter="shape" data-value="${shape}" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove ${shape}" data-no-instant>
            <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
              <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
          </a>
          <span class="text-subdued">Shape: ${shape}</span>
        </div>
      `
    })
  }

  if (queryParams['certified_by[]'] && queryParams['certified_by[]'].length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    queryParams['certified_by[]'].forEach(item => {
      const certificates = queryParams['certified_by[]'].filter(s => s !== item);
      cloneParams.delete("certified_by[]");
      certificates.forEach(cert => {
        cloneParams.append("certified_by[]", cert);
      });
      html += `
        <div class="removable-facet">
          <a href="" data-filter="certified_by" data-value="${item}" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove ${item}" data-no-instant>
            <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
              <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
          </a>
          <span class="text-subdued">${item}</span>
        </div>
      `
    })
  }

  if (queryParams['heart_arrow']) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    cloneParams.delete("heart_arrow");
    html += `
      <div class="removable-facet">
        <a href="" data-filter="heart_arrow" data-value="${queryParams['heart_arrow']}" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove Heart & Arrow" data-no-instant>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span class="text-subdued">Heart & Arrow</span>
      </div>
    `
  }

  if (queryParams['types[]'] && queryParams['types[]'].length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    queryParams['types[]'].forEach(item => {
      const types = queryParams['types[]'].filter(s => s !== item);
      cloneParams.delete("types[]");
      types.forEach(cert => {
        cloneParams.append("types[]", cert);
      });
      html += `
        <div class="removable-facet">
          <a href="" data-filter="types" data-value="${item}" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove ${item}" data-no-instant>
            <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
              <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
          </a>
          <span class="text-subdued">Type: ${decodeURI(item)}</span>
        </div>
      `
    })
  }

  if (queryParams['color[]'] && queryParams['color[]'].length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    queryParams['color[]'].forEach(item => {
      const certificates = queryParams['color[]'].filter(s => s !== item);
      cloneParams.delete("color[]");
      certificates.forEach(cert => {
        cloneParams.append("color[]", cert);
      });
      html += `
        <div class="removable-facet">
          <a href="" data-filter="color" data-value="${item}" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove ${item}" data-no-instant>
            <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
              <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
          </a>
          <span class="text-subdued">Color: ${decodeURI(item)}</span>
        </div>
      `
    })
  }

  if (queryParams['fancy[]'] && queryParams['fancy[]'].length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    queryParams['fancy[]'].forEach(item => {
      const certificates = queryParams['fancy[]'].filter(s => s !== item);
      cloneParams.delete("fancy[]");
      certificates.forEach(cert => {
        cloneParams.append("fancy[]", cert);
      });
      html += `
        <div class="removable-facet">
          <a href="" data-filter="fancy" data-value="${item}" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove ${item}" data-no-instant>
            <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
              <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
          </a>
          <span class="text-subdued">Fancy Color Intensity:${decodeURI(item)}</span>
        </div>
      `
    })
  }

  let cuts = queryParams['cuts[]']
  if (cuts && cuts.length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    cloneParams.delete("cuts[]");
    html += `
      <div class="removable-facet">
        <a href="" data-filter="cuts" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove Cut" data-no-instant>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span class="text-subdued">Cut: ${cuts[0]} to ${cuts[cuts.length - 1]}</span>
      </div>
    `
  }

  let colors = queryParams['colors[]']
  if (colors && colors.length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    cloneParams.delete("colors[]");
    html += `
      <div class="removable-facet">
        <a href="" data-filter="colors" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove Color" data-no-instant>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span class="text-subdued">Color: ${colors[0]} to ${colors[colors.length - 1]}</span>
      </div>
    `
  }

  let claritys = queryParams['claritys[]']
  if (claritys && claritys.length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    cloneParams.delete("claritys[]");
    html += `
      <div class="removable-facet">
        <a href="" data-filter="claritys" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove Clarity" data-no-instant>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span class="text-subdued">Clarity: ${claritys[0]} to ${claritys[claritys.length - 1]}</span>
      </div>
    `
  }

  let polishs = queryParams['polishs[]']
  if (polishs && polishs.length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    cloneParams.delete("polishs[]");
    html += `
      <div class="removable-facet">
        <a href="" data-filter="polishs" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove polish" data-no-instant>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span class="text-subdued">Polish: ${polishs[0]} to ${polishs[polishs.length - 1]}</span>
      </div>
    `
  }

  let symmetrys = queryParams['symmetrys[]']
  if (symmetrys && symmetrys.length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    cloneParams.delete("symmetrys[]");
    html += `
      <div class="removable-facet">
        <a href="" data-filter="symmetrys" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove symmetry" data-no-instant>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span class="text-subdued">Symmetry: ${symmetrys[0]} to ${symmetrys[symmetrys.length - 1]}</span>
      </div>
    `
  }

  let fluorescences = queryParams['fluorescences[]']
  if (fluorescences && fluorescences.length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    cloneParams.delete("fluorescences[]");
    html += `
      <div class="removable-facet">
        <a href="" data-filter="fluorescences" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove fluorescence" data-no-instant>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span class="text-subdued">Fluorescence: ${fluorescences[0]} to ${fluorescences[fluorescences.length - 1]}</span>
      </div>
    `
  }

  let carats = queryParams['carats[]']
  if (carats && carats.length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    cloneParams.delete("carats[]");
    html += `
      <div class="removable-facet">
        <a href="" data-filter="carats" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove Carat" data-no-instant>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span class="text-subdued">Carat: ${carats[0]} to ${carats[1]}</span>
      </div>
    `
  }

  let prices = queryParams['prices[]']
  if (prices && prices.length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    cloneParams.delete("prices[]");
    html += `
      <div class="removable-facet">
        <a href="" data-filter="prices" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove Price" data-no-instant>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span class="text-subdued">Price: ${prices[0]} to ${prices[1]}</span>
      </div>
    `
  }

  let ratios = queryParams['ratios[]']
  if (ratios && ratios.length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    cloneParams.delete("ratios[]");
    html += `
      <div class="removable-facet">
        <a href="" data-filter="ratios" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove Ratios" data-no-instant>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span class="text-subdued">L/W Ratio: ${ratios[0]} to ${ratios[1]}</span>
      </div>
    `
  }

  let tables = queryParams['tables[]']
  if (tables && tables.length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    cloneParams.delete("tables[]");
    html += `
      <div class="removable-facet">
        <a href="" data-filter="tables" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove tables" data-no-instant>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span class="text-subdued">Table: ${tables[0]}% to ${tables[1]}%</span>
      </div>
    `
  }

  let depths = queryParams['depths[]']
  if (depths && depths.length > 0) {
    const clonedUrl = new URL(url);
    const cloneParams = clonedUrl.searchParams;
    cloneParams.delete("depths[]");
    html += `
      <div class="removable-facet">
        <a href="" data-filter="depths" data-url="${clonedUrl}" is="remove-link" class="tap-area link-faded" aria-label="Remove depths" data-no-instant>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span class="text-subdued">Depth: ${depths[0]}% to ${depths[1]}%</span>
      </div>
    `
  }

  if (queryParams['shape[]'] || queryParams['certified_by[]'] || queryParams['color[]'] || queryParams['fancy[]'] || queryParams['cuts[]'] || queryParams['colors[]'] || queryParams['claritys[]'] || queryParams['polishs[]'] || queryParams['symmetrys[]'] || queryParams['fluorescences[]'] || queryParams['ratios[]'] || queryParams['tables[]'] || queryParams['depths[]'] || queryParams['types[]']) {
    params.delete("shape[]");
    params.delete("certified_by[]");
    params.delete("color[]");
    params.delete("fancy[]");
    params.delete("cuts[]");
    params.delete("colors[]");
    params.delete("claritys[]");
    params.delete("carats[]");
    params.delete("prices[]");
    params.delete("ratios[]");
    params.delete("tables[]");
    params.delete("depths[]");
    params.delete("types[]");
    params.delete("fluorescences[]");
    params.delete("polishs[]");
    params.delete("symmetrys[]");
    params.delete("ai");
    html += `
      <a href="" data-url="${url}" is="removeall-link" class="facets-clear-all text-subdued">
        <span class="link">Clear All</span>
      </a>
    `
  }

  html += '</div></div>'

  return html;
}

var DiamondsForm = class extends HTMLFormElement {
  constructor() {
    super();

    this.buildUrl = "";
    this.isDirty = false;
    this.addEventListener("change", this.onFormChanged.bind(this));
    this.addEventListener("submit", this.onFormSubmitted.bind(this));
  }

  onFormChanged(event) {
    this.isDirty = true
    this.dispatchEvent(new Event("submit", { cancelable: true }));
  }

  buildUrlCallback() {
    let url = new URL(this.action);
    const formData = new FormData(this);
    const formValues = {};
    for (let [name, value] of formData.entries()) {
      if (formValues[name]) {
        if (Array.isArray(formValues[name])) {
          formValues[name].push(value);
        }
      } else {
        if (name === "shape[]" || name === "certified_by[]" || name === "color[]" || name === "fancy[]" || name === "types[]") {
          formValues[name] = [value];
        } else {
          formValues[name] = value;
        }
      }
    }

    const params = url.searchParams;

    let colors = window.themeVariables.settings.filters.colors || [];
    let colorMin = formValues.color_min;
    let colorMax = formValues.color_max;

    let selectedColors = [];
    if (colorMin && colorMax) {
      const minIndex = colors.indexOf(decodeURI(colorMin));
      const maxIndex = colors.indexOf(decodeURI(colorMax));

      if (minIndex !== -1 && maxIndex !== -1) {
        selectedColors = colors.slice(minIndex, maxIndex + 1);
      }
    } else {
      selectedColors = colors;
    }

    let cuts = window.themeVariables.settings.filters.cuts || [];
    let cutMin = formValues.cut_min;
    let cutMax = formValues.cut_max;

    let selectedCuts = [];
    if (cutMin && cutMax) {
      const minIndex = cuts.indexOf(decodeURI(cutMin));
      const maxIndex = cuts.indexOf(decodeURI(cutMax));

      if (minIndex !== -1 && maxIndex !== -1) {
        selectedCuts = cuts.slice(minIndex, maxIndex + 1);
      }
    } else {
      selectedCuts = cuts;
    }

    let claritys = window.themeVariables.settings.filters.clarities || [];
    let clarityMin = formValues.clarity_min;
    let clarityMax = formValues.clarity_max;

    let selectedClarities = [];
    if (clarityMin && clarityMax) {
      const minIndex = claritys.indexOf(decodeURI(clarityMin));
      const maxIndex = claritys.indexOf(decodeURI(clarityMax));

      if (minIndex !== -1 && maxIndex !== -1) {
        selectedClarities = claritys.slice(minIndex, maxIndex + 1);
      }
    } else {
      selectedClarities = claritys;
    }

    let symmetrys = window.themeVariables.settings.filters.symmetrys || [];
    let symmetryMin = formValues.symmetry_min;
    let symmetryMax = formValues.symmetry_max;

    let selectedsymmetrys = [];
    if (symmetryMin && symmetryMax) {
      const minIndex = symmetrys.indexOf(decodeURI(symmetryMin));
      const maxIndex = symmetrys.indexOf(decodeURI(symmetryMax));

      if (minIndex !== -1 && maxIndex !== -1) {
        selectedsymmetrys = symmetrys.slice(minIndex, maxIndex + 1);
      }
    } else {
      selectedsymmetrys = symmetrys;
    }

    let polishs = window.themeVariables.settings.filters.polishs || [];
    let polishMin = formValues.polish_min;
    let polishMax = formValues.polish_max;

    let selectedpolishs = [];
    if (polishMin && polishMax) {
      const minIndex = polishs.indexOf(decodeURI(polishMin));
      const maxIndex = polishs.indexOf(decodeURI(polishMax));

      if (minIndex !== -1 && maxIndex !== -1) {
        selectedpolishs = polishs.slice(minIndex, maxIndex + 1);
      }
    } else {
      selectedpolishs = polishs;
    }

    let fluorescences = window.themeVariables.settings.filters.fluorescences || [];
    let fluorescenceMin = formValues.fluorescence_min;
    let fluorescenceMax = formValues.fluorescence_max;

    let selectedfluorescences = [];
    if (fluorescenceMin && fluorescenceMax) {
      const minIndex = fluorescences.indexOf(decodeURI(fluorescenceMin));
      const maxIndex = fluorescences.indexOf(decodeURI(fluorescenceMax));

      if (minIndex !== -1 && maxIndex !== -1) {
        selectedfluorescences = fluorescences.slice(minIndex, maxIndex + 1);
      }
    } else {
      selectedfluorescences = fluorescences;
    }

    if (formValues.ai && !formValues.user && formValues['shape[]'] && formValues['shape[]'].length > 0) {
      switch (formValues['shape[]'][0]) {
        case 'Round':
          formValues.ratio_min = "1";
          formValues.ratio_max = "1";
          formValues.table_min = "51.5";
          formValues.table_max = "63";
          formValues.depth_min = "58";
          formValues.depth_max = "62.3";
          selectedCuts = ['Excellent', 'Ideal']
          break;
        case 'Oval':
          formValues.ratio_min = "1";
          formValues.ratio_max = "3";
          formValues.table_min = "52";
          formValues.table_max = " 62";
          formValues.depth_min = "59";
          formValues.depth_max = "63";
          selectedCuts = window.themeVariables.settings.filters.cuts
          break;
        case 'Emerald':
          formValues.ratio_min = "1";
          formValues.ratio_max = "3";
          formValues.table_min = "58";
          formValues.table_max = "69.5";
          formValues.depth_min = "60";
          formValues.depth_max = "65";
          selectedCuts = window.themeVariables.settings.filters.cuts
          break;
        case 'Pear':
          formValues.ratio_min = "1";
          formValues.ratio_max = "3";
          formValues.table_min = "52";
          formValues.table_max = "62";
          formValues.depth_min = "59";
          formValues.depth_max = "63";
          selectedCuts = window.themeVariables.settings.filters.cuts
          break;
        case 'Princess':
          formValues.ratio_min = "1";
          formValues.ratio_max = "3";
          formValues.table_min = "64";
          formValues.table_max = "75";
          formValues.depth_min = "59";
          formValues.depth_max = "74";
          selectedCuts = window.themeVariables.settings.filters.cuts
          break;
        case 'Cushion':
          formValues.ratio_min = "1";
          formValues.ratio_max = "3";
          formValues.table_min = "64";
          formValues.table_max = "75";
          formValues.depth_min = "59";
          formValues.depth_max = "74";
          selectedCuts = window.themeVariables.settings.filters.cuts
          break;
        case 'Radiant':
          formValues.ratio_min = "1";
          formValues.ratio_max = "3";
          formValues.table_min = "58";
          formValues.table_max = "69.5";
          formValues.depth_min = "60";
          formValues.depth_max = "65";
          selectedCuts = window.themeVariables.settings.filters.cuts
          break;
        case 'Marquise':
          formValues.ratio_min = "1";
          formValues.ratio_max = "3";
          formValues.table_min = "52";
          formValues.table_max = "62";
          formValues.depth_min = "59";
          formValues.depth_max = "63";
          selectedCuts = window.themeVariables.settings.filters.cuts
          break;
        case 'Heart':
          formValues.ratio_min = "1";
          formValues.ratio_max = "3";
          formValues.table_min = "59";
          formValues.table_max = "63";
          formValues.depth_min = "52";
          formValues.depth_max = "62";
          selectedCuts = window.themeVariables.settings.filters.cuts
          break;
        default:
      }
    }

    for (let key in formValues) {
      if (Array.isArray(formValues[key])) {
        formValues[key].forEach(value => {
          params.append(key, encodeURIComponent(value));
        });
      } else {
        params.set(key, encodeURIComponent(formValues[key]));
      }
    }

    params.set("section_id", this.getAttribute("section-id"));

    if (selectedColors.length < colors.length) {
      selectedColors.forEach(color => {
        params.append("colors[]", color);
      });
    }
    if (selectedCuts.length < cuts.length) {
      selectedCuts.forEach(cut => {
        params.append("cuts[]", cut);
      });
    }
    if (selectedClarities.length < claritys.length) {
      selectedClarities.forEach(clarity => {
        params.append("claritys[]", clarity);
      });
    }

    if (selectedsymmetrys.length < symmetrys.length) {
      selectedsymmetrys.forEach(v => {
        params.append("symmetrys[]", v);
      });
    }

    if (selectedpolishs.length < polishs.length) {
      selectedpolishs.forEach(v => {
        params.append("polishs[]", v);
      });
    }

    if (selectedfluorescences.length < fluorescences.length) {
      selectedfluorescences.forEach(v => {
        params.append("fluorescences[]", v);
      });
    }

    if (formValues.carat_min > themeVariables.settings.filters.carat_min || formValues.carat_max < themeVariables.settings.filters.carat_max) {
      params.append("carats[]", formValues.carat_min);
      params.append("carats[]", formValues.carat_max);
    }

    if (formValues.price_min > themeVariables.settings.filters.price_min || formValues.price_max < themeVariables.settings.filters.price_max) {
      params.append("prices[]", formValues.price_min);
      params.append("prices[]", formValues.price_max);
    }

    if (formValues.ratio_min > themeVariables.settings.filters.ratio_min || formValues.ratio_max < themeVariables.settings.filters.ratio_max) {
      params.append("ratios[]", formValues.ratio_min);
      params.append("ratios[]", formValues.ratio_max);
    }

    if (formValues.table_min > themeVariables.settings.filters.table_min || formValues.table_max < themeVariables.settings.filters.table_max) {
      params.append("tables[]", formValues.table_min);
      params.append("tables[]", formValues.table_max);
    }

    if (formValues.depth_min > themeVariables.settings.filters.depth_min || formValues.depth_max < themeVariables.settings.filters.depth_max) {
      params.append("depths[]", formValues.depth_min);
      params.append("depths[]", formValues.depth_max);
    }

    params.delete("carat_min");
    params.delete("carat_max");
    params.delete("price_min");
    params.delete("price_max");
    params.delete("ratio_max");
    params.delete("ratio_min");
    params.delete("table_min");
    params.delete("table_max");
    params.delete("depth_max");
    params.delete("depth_min");
    params.delete("color_min");
    params.delete("color_max");
    params.delete("cut_min");
    params.delete("cut_max");
    params.delete("clarity_min");
    params.delete("clarity_max");
    params.delete("polish_min");
    params.delete("polish_max");
    params.delete("symmetry_min");
    params.delete("symmetry_max");
    params.delete("fluorescence_min");
    params.delete("fluorescence_max");

    return url;
  }

  onFormSubmitted(event) {
    event.preventDefault();
    if (!this.isDirty) {
      return;
    }

    this.dispatchEvent(new CustomEvent("diamond:update", {
      bubbles: true,
      detail: {
        url: this.buildUrlCallback(),
        scroll: false
      }
    }));
    this.isDirty = false
  }
};

if (!window.customElements.get("diamonds-form")) {
  window.customElements.define("diamonds-form", DiamondsForm, { extends: "form" });
}

var DiamondLink = class extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener("click", this.onFacetUpdate.bind(this));
  }

  onFacetUpdate(event) {
    event.preventDefault();
    const url = new URL(this.dataset.url);
    this.dispatchEvent(new CustomEvent("diamond:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }
};

if (!window.customElements.get("diamond-link")) {
  window.customElements.define("diamond-link", DiamondLink, { extends: "a" });
}

var RemoveLink = class extends HTMLAnchorElement {
  constructor() {
    super();
    this.filter = this.dataset.filter
    this.value = this.dataset.value

    this.addEventListener("click", this.onFacetUpdate.bind(this));
  }

  onFacetUpdate(event) {
    event.preventDefault();

    const diamond_filters = localStorage.getItem('diamond_filters')
    if (diamond_filters) {
      const filters = JSON.parse(diamond_filters)
      if (this.value) {
        filters[this.filter] = filters[this.filter].filter(item => item !== this.value);
      } else {
        delete filters[this.filter];
      }
      localStorage.setItem('diamond_filters', JSON.stringify(filters))
    }

    const url = new URL(this.dataset.url);
    this.dispatchEvent(new CustomEvent("diamond:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }
};

if (!window.customElements.get("remove-link")) {
  window.customElements.define("remove-link", RemoveLink, { extends: "a" });
}

var RemoveAllLink = class extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener("click", this.onFacetUpdate.bind(this));
  }

  onFacetUpdate(event) {
    event.preventDefault();
    localStorage.removeItem('diamond_filters')
    const url = new URL(this.dataset.url);
    this.dispatchEvent(new CustomEvent("diamond:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }
};

if (!window.customElements.get("removeall-link")) {
  window.customElements.define("removeall-link", RemoveAllLink, { extends: "a" });
}

var DiamondTable = class extends HTMLElement {
  constructor() {
    super();
    const filters = localStorage.getItem('diamond_filters')
    if (filters) {
      this.filters = JSON.parse(filters)
    }
  }
  connectedCallback() {
    const url = new URL(this.dataset.url)
    const params = url.searchParams;
    const urlParams = new URLSearchParams(window.location.search);
    params.set("section_id", extractSectionId(this));

    const ai = urlParams.get('ai');
    if (ai) {
      params.append("ai", 1);
    }

    const shape = urlParams.get('shape');
    if (shape) {
      const shapes = shape.split('|')
      shapes.forEach(v => {
        params.append("shape[]", v);
      });
    }

    const cut = urlParams.get('cut');
    if (cut) {
      const cuts = decodeURI(cut).split('|')
      cuts.forEach(v => {
        params.append("cuts[]", v);
      });
    }

    const price = urlParams.get('price');
    if (price) {
      const prices = decodeURI(price).split('|')
      prices.forEach(v => {
        params.append("prices[]", v);
      });
    }

    const carat = urlParams.get('carat');
    if (carat) {
      const carats = decodeURI(carat).split('|')
      carats.forEach(v => {
        params.append("carats[]", v);
      });
    }

    const clarity = urlParams.get('clarity');
    if (clarity) {
      const claritys = decodeURI(clarity).split('|')
      claritys.forEach(v => {
        params.append("claritys[]", v);
      });
    }

    const color = urlParams.get('color');
    if (color) {
      const colors = decodeURI(color).split('|')
      colors.forEach(v => {
        params.append("colors[]", v);
      });
    }

    const colorfull = urlParams.get('colorfull');
    if (colorfull) {
      const colorfulls = decodeURI(colorfulls).split('|')
      colorfulls.forEach(v => {
        params.append("color[]", v);
      });
    }

    const polish = urlParams.get('polish');
    if (polish) {
      const polishes = decodeURI(polish).split('|')
      polishes.forEach(v => {
        params.append("polishs[]", v);
      });
    }

    const symmetry = urlParams.get('symmetry');
    if (symmetry) {
      const symmetries = decodeURI(symmetry).split('|')
      symmetries.forEach(v => {
        params.append("symmetrys[]", v);
      });
    }

    const fluorescence = urlParams.get('fluorescence');
    if (fluorescence) {
      const fluorescences = decodeURI(fluorescence).split('|')
      fluorescences.forEach(v => {
        params.append("fluorescences[]", v);
      });
    }

    const fancy = urlParams.get('fancy');
    if (fancy) {
      const fancys = decodeURI(fancy).split('|')
      fancys.forEach(v => {
        params.append("fancy[]", v);
      });
    }

    const type = urlParams.get('type');
    if (type) {
      const types = decodeURI(type).split('|')
      types.forEach(v => {
        params.append("types[]", v);
      });
    }


    const angle = urlParams.get('angle');
    if (angle) {
      const angles = decodeURI(angle).split('|')
      angles.forEach(v => {
        params.append("angles[]", v);
      });
    }

    const ratio = urlParams.get('ratio');
    if (ratio) {
      const ratios = decodeURI(ratio).split('|')
      ratios.forEach(v => {
        params.append("ratios[]", v);
      });
    }

    const table = urlParams.get('table');
    if (table) {
      const tables = decodeURI(table).split('|')
      tables.forEach(v => {
        params.append("tables[]", v);
      });
    }

    const depth = urlParams.get('depth');
    if (depth) {
      const depths = decodeURI(depth).split('|')
      depths.forEach(v => {
        params.append("depths[]", v);
      });
    }

    const certificate = urlParams.get('certificate');
    if (certificate) {
      const certified_by = decodeURI(certificate).split('|')
      certified_by.forEach(v => {
        params.append("certified_by[]", v);
      });
    }

    if (this.filters) {
      if (this.filters.shape && this.filters.shape.length > 0) {
        for (let i = 0; i < this.filters.shape.length; i++) {
          params.set("shape[]", this.filters.shape[i]);
        }
      }
      if (this.filters.carats && this.filters.carats.length > 0) {
        params.set("carats[]", this.filters.carats[0]);
        params.append("carats[]", this.filters.carats[1]);
      }
    }

    this.querySelectorAll('.js-diamond-listing-sort').forEach(a => a.addEventListener('click', this.handleSort.bind(this)));

    const paramsString = sessionStorage.getItem('current_filters')
    if (paramsString) {
      const savedParams = new URLSearchParams(paramsString);
      const hasShapeParam = savedParams.has('shape[]');
      const hasCaratsParam = savedParams.has('carats[]');
      if (hasShapeParam) {
        params.delete("shape[]");
      }
      if (hasCaratsParam) {
        params.delete("carats[]");
      }
      params.delete("certified_by[]");
      params.delete("color[]");
      params.delete("fancy[]");
      params.delete("cuts[]");
      params.delete("colors[]");
      params.delete("claritys[]");
      params.delete("prices[]");
      params.delete("ratios[]");
      params.delete("tables[]");
      params.delete("depths[]");
      params.delete("types[]");
      params.delete("fluorescences[]");
      params.delete("polishs[]");
      params.delete("symmetrys[]");
      params.delete("section_id")
      for (const [name, value] of savedParams) {
        if (params.has(decodeURI(name))) {
          params.append(decodeURI(name), value);
        } else {
          params.set(decodeURI(name), value);
        }
      }
    }

    this.reload(url)
  }

  handleSort(e) {
    const dir = e.target.getAttribute('sort-to')
    const url = new URL(this.dataset.url)
    const params = url.searchParams;
    params.set('sort_by', e.target.dataset.attr);
    params.set('sort_direction', dir)
    if (dir === 'asc') {
      e.target.setAttribute('sort-to', 'desc')
    } else {
      e.target.setAttribute('sort-to', 'asc')
    }

    this.querySelectorAll('.js-diamond-listing-sort').forEach(a => a.classList.remove('active'))
    e.target.classList.add('active')

    this.dispatchEvent(new CustomEvent("diamond:update", {
      bubbles: true,
      detail: {
        url: url
      }
    }));
  }

  reload(url) {
    this.dispatchEvent(new CustomEvent("diamond:update", {
      bubbles: true,
      detail: {
        url: url
      }
    }));
  }
}

if (!window.customElements.get("diamond-table")) {
  window.customElements.define("diamond-table", DiamondTable);
}

document.querySelectorAll('[name="shape[]"]').forEach(shape => {
    shape.addEventListener('change', function (e) {
        const userField = document.querySelector('[name=user]');
        userField.checked = false;
    });
})
